import React from 'react'
import { IconInfoDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'

interface ClarifyMultipleProfilesAtSignUpMessageProps {
  className?: string
  location?: 'checkout' | 'default'
}

export const ClarifyMultipleProfilesAtSignUpMessage = ({
  className,
  location = 'default',
}: ClarifyMultipleProfilesAtSignUpMessageProps) => {
  const { t } = useTranslation('@mc/authentication')

  // Apply responsive alignment based on location
  const alignmentClasses =
    location === 'checkout'
      ? 'align-items-start align-items-sm-center mc-text--left mc-text-sm--center'
      : 'align-items-start'

  return (
    <div
      className={`mc-bg-container-medium  mc-p-2 mc-corners--2 ${className}`}
      role='note'
      aria-live='polite'
    >
      <div className={`d-flex ${alignmentClasses}`}>
        <span
          aria-hidden
          className='mc-mr-2 mc-opacity--muted d-flex align-items-center'
        >
          <IconInfoDefault width='12' height='12' />
        </span>
        <p className='mc-text-x-small mc-opacity--muted mc-mb-0'>
          {t('clarifyMultipleProfiles.message')}
        </p>
      </div>
    </div>
  )
}
